import { render, staticRenderFns } from "./newtask_template.vue?vue&type=template&id=c7ba446e&scoped=true"
import script from "./newtask_template.vue?vue&type=script&lang=js"
export * from "./newtask_template.vue?vue&type=script&lang=js"
import style0 from "./newtask_template.vue?vue&type=style&index=0&id=c7ba446e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7ba446e",
  null
  
)

export default component.exports